import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";

export function LandingNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // set click event for close menu
    const handleClickOutside = (event: MouseEvent) => {
      if (
        event.target instanceof HTMLElement &&
        !event.target.closest(".nav-links") &&
        !event.target.closest("#mobile-menu-btn")
      ) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    // set resize event for close menu
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-cream/95 backdrop-blur-sm border-b border-tea-brown/20">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          <div class="flex items-center space-x-3">
            <Link to={ROUTES.HOME}>
              <img
                src="/assets/images/logo.jpg"
                alt="麻薏 Mayi AI Logo"
                className="w-8 h-8 rounded-sm object-cover"
              />
            </Link>
            <div>
              <span class="text-lg font-semibold text-earth-green handwriting">
                麻薏 Mayi AI
              </span>
              <div class="text-xs text-tea-brown">台中・智慧營運助理</div>
            </div>
          </div>

          <div class="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              class="text-tea-brown hover:text-earth-green transition-colors"
            >
              服務特色
            </a>
            <a
              href="#story"
              class="text-tea-brown hover:text-earth-green transition-colors"
            >
              在地故事
            </a>
            <a
              href="#contact"
              class="text-tea-brown hover:text-earth-green transition-colors"
            >
              聯絡我們
            </a>
            <a
              href={ROUTES.LOGIN}
              class="bg-earth-green text-cream px-6 py-2 rounded-full hover:bg-soft-green transition-colors font-medium card-shadow"
            >
              開始使用
            </a>
          </div>

          <button
            class="md:hidden p-2"
            id="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i class="fas fa-bars text-tea-brown"></i>
          </button>
        </div>

        <div
          class="md:hidden border-t border-tea-brown/20 py-4"
          id="mobile-menu"
          style={{ display: isMenuOpen ? "block" : "none" }}
        >
          <div class="space-y-3">
            <a
              href="#features"
              class="block py-2 text-tea-brown hover:text-earth-green transition-colors"
            >
              服務特色
            </a>
            <a
              href="#story"
              class="block py-2 text-tea-brown hover:text-earth-green transition-colors"
            >
              在地故事
            </a>
            <a
              href="#contact"
              class="block py-2 text-tea-brown hover:text-earth-green transition-colors"
            >
              聯絡我們
            </a>
            <a
              href={ROUTES.LOGIN}
              class="block bg-earth-green text-cream px-4 py-2 rounded-full text-center mt-4"
            >
              開始使用
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
